// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2UIQy","paramInput":"JobSimulator_paramInput__2xJP5","input":"JobSimulator_input__11N9K"};